import {computed, inject, Injectable, signal} from '@angular/core'
import {CanActivateFn, Router} from '@angular/router'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {
  CREDIT_ROLE,
  CUSTOMER_SUPPORT_ROLE,
  FM_ADMIN_ROLE,
  INTERNAL_SUPPORT_ROLE,
  RoleKey,
  WATCH_ROLE
} from './types'

export const canActivateFileView: CanActivateFn = () => {
  return inject(RoleHelper).fileView() ? true : inject(Router).parseUrl('/')
}

export const canActivateBulkView: CanActivateFn = () => {
  return inject(RoleHelper).bulkView() ? true : inject(Router).parseUrl('/')
}

@Injectable({
  providedIn: 'root'
})
export class RoleHelper {
  public isSimulating = computed(() => this.simulatedRole() !== null)

  public isCustomerSupport = computed(() =>
    this.userRoles().includes(CUSTOMER_SUPPORT_ROLE)
  )

  public isInternalSupport = computed(() =>
    this.userRoles().includes(INTERNAL_SUPPORT_ROLE)
  )
  public isWatcher = computed(() =>
    this.userRoles().includes(WATCH_ROLE)
  )
  public isCredit = computed(() =>
    this.userRoles().includes(CREDIT_ROLE)
  )

  public isFMAdmin = computed(() =>
    this.userRoles().includes(FM_ADMIN_ROLE)
  )

  public fileView = computed(() => {
    const roles = this.userRoles()
    return roles.includes(CREDIT_ROLE) || roles.includes(INTERNAL_SUPPORT_ROLE) || roles.includes(CUSTOMER_SUPPORT_ROLE)
  })

  public bulkView = computed(() => {
    const roles = this.userRoles()
    return roles.includes(CREDIT_ROLE) || roles.includes(INTERNAL_SUPPORT_ROLE)
  })

  private readonly service = inject(ConfigService)

  // Holds the simulated role if it's set
  private simulatedRole = signal<string | null>(null)

  // Prioritizes the simulated role if it exists, otherwise uses the user's actual roles.
  private readonly userRoles = computed(() => {
    const role = this.simulatedRole()
    if (role) {
      return [role]
    }
    return this.service.currentUser()?.roles ?? []
  })

  // Switch or reset the view from the component
  public setView(role: RoleKey | null) {
    this.simulatedRole.set(role ? role : null)
  }
}